/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * pharmacysearchwidget.js: Feature level module
	 * @description This module is used for : 
	 * 										1. Displaying formulary drugs for both(Example of Savings\Pet Medications)
	 * 										2. Displaying auto suggest drug list
	 * 										3. Form submission after click on the Compare Price button and Press Enter Button 										
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
	
		var PharmacySearchWidget = {
			/**
	      * Drug Search Min. Length Configuration
	      */
			drugSearchMinLength: 1,
			/**
	      * Drug Search Max. Length Configuration
	      */
			drugSearchMaxLength: 2,
			/**
	      * Enter Keyword Code
	      */
			EnterKeywordCode: 13,
			/**
	      * Enter Keyword Code
	      */
			petFormularyId: '',
	
			/**
	   * getAutoSuggestedDrugAuthDetails is a method is used for getting the API End-Point and Token Information from the back-end.
	   * This method hit an external API for getting the auto suggested drug list for a keyword provided in the text field
	   * This method invokes a method getAutoSuggestedDrugNamesByKeyword to display the results
	   * Condition : If the character length is more than 2
	   * Ex: 'fl' >> Flovent HFA, Fluad etc..!
	   * @param : keyword
	   */
			getAutoSuggestedDrugAuthDetails: function getAutoSuggestedDrugAuthDetails(keyword) {
				var CMPP_DRUG_SEARCH_END_POINT = 'CMPP_DRUG_SEARCH_END_POINT';
				var apiURL = '';
				var token = '';
				var displayError = '';
				var responseTimeout = 0;
				$('.cmppAutoSuggest').hide();
				//Setting the empty data to the respective #div_drugNameAutoSuggestionsError before inserting the data
				$('#div_drugNameAutoSuggestionsError').html(displayError);
				$.get('/AjaxCostcoCMPPDrugAuthDetailsLookupView?action=token&apiName=' + CMPP_DRUG_SEARCH_END_POINT).done(function (data) {
					var object = JSON.parse(data);
					apiURL = object.apiURL;
					token = object.token;
					responseTimeout = object.responseTimeout;
					jQuery.ajax({
						url: apiURL + keyword,
						type: 'GET',
						timeout: responseTimeout,
						headers: {
							'Content-Type': 'application/json',
							'Accept': "application/json",
							'api-version': object.apiVersionNumber
						},
						beforeSend: function beforeSend(xhr) {
							xhr.setRequestHeader('Authorization', 'Bearer ' + token);
						},
						success: function success(response) {
							$('.mpp-title-error-message').hide();
							if (response.length > 0) {
								$('#cmppDrugNameTextID').attr('aria-invalid', 'false');
								PharmacySearchWidget.getAutoSuggestedDrugNamesByKeyword(response);
							} else {
								$('#div_drugNameAutoSuggestionsError').show();
								$('#cmppDrugNameTextID').addClass('error');
								$('#cmppDrugNameTextID').attr('aria-invalid', 'true');
								$('#div_drugNameAutoSuggestionsError').addClass('error');
								displayError += COSTCO.util.tmpl('templ_drug_names_suggestions_error_display', {});
								$('#div_drugNameAutoSuggestionsError').html(displayError);
								$('.cmppAutoSuggest').hide();
							}
						},
						error: function error(xhr, ajaxOptions, thrownError) {
							$('.mpp-title-error-message').show();
							$('.mpp-title').hide();
						}
					});
				});
			},
	
			/**
	   * getAutoSuggestedDrugNamesByKeyword is a method is used for displaying the drug suggestions for the characters search by a customer.
	   * This method is invoke by the primary method getAutoSuggestedDrugAuthDetails
	   */
			getDisplayDrugTextFields: function getDisplayDrugTextFields() {
				$('#cmppDrugNameTextID').val("");
				$('.mpp-title').show();
				$('.mpp-title-error-message').hide();
			},
			getAutoSuggestedDrugNamesByKeyword: function getAutoSuggestedDrugNamesByKeyword(data) {
				var displaySuggestedNames = '';
				var errorText = '';
				//Setting the empty data to the respective #div_drugNameAutoSuggestions before inserting the data
				$('#div_drugNameAutoSuggestions').html(displaySuggestedNames);
				var object = data;
				displaySuggestedNames = "<ul id='autoSuggestionsId'>";
				for (var i in object) {
					displaySuggestedNames += COSTCO.util.tmpl('templ_drug_names_suggestions_display', {
						drugId: object[i].drugIdentifier,
						drugName: object[i].drugName
					});
				}
				displaySuggestedNames = displaySuggestedNames + '</ul>';
				$('#div_drugNameAutoSuggestions').html(displaySuggestedNames);
				$('.cmppAutoSuggest').show();
				$("#cmppDrugNameTextID").keyup(function () {
					$('#drugNameParam').val($(this).val());
					$('#drugIdentifierParam').val($('ul#autoSuggestionsId li:first').attr('id'));
				});
				$('#autoSuggestionsId li').keyup(function (e) {
					if (e.keyCode == 13) {
						$('#drugNameParam').val($(this).text());
						$('#drugIdentifierParam').val($(this).attr('id'));
						$('#cmppDrugNameTextID').val($(this).text());
						$('.cmppAutoSuggest').hide();
						$('#cmppSubmitId').click();
					}
				});
				$('#autoSuggestionsId li.selected').keyup(function (e) {
					if (e.keyCode == 13) {
						$('#drugNameParam').val($(this).text());
						$('#drugIdentifierParam').val($(this).attr('id'));
						$('#cmppDrugNameTextID').val($(this).text());
						$('.cmppAutoSuggest').hide();
						$('#cmppSubmitId').click();
					}
				});
				$('#autoSuggestionsId li').click(function () {
					$('#drugNameParam').val($(this).text());
					$('#drugIdentifierParam').val($(this).attr('id'));
					$('#cmppDrugNameTextID').val($(this).text());
					$('.cmppAutoSuggest').hide();
					$('#cmppSubmitId').click();
				});
			},
	
			/**
	   * getFormularySavingsDrugAuthDetails is a method is used for getting the API End-Point and Token Information from the back-end.
	   * This method hit an external API for getting the formulary drug list 
	   * This method invokes a method getFormularySavingProductsById to display the results
	   * This method invokes a method getFormularyNewProductsById to display drugs new to CMPP in carousel
	   * @param : formularyId
	   */
			getFormularySavingsDrugAuthDetails: function getFormularySavingsDrugAuthDetails() {
				var CMPP_DRUG_SEARCH_END_POINT = 'CMPP_FORMULARY_PRODUCTS_BY_ID_END_POINT';
				var apiURL = '';
				var token = '';
				var formularyId = '';
				var responseTimeout = 0;
				$.get('/AjaxCostcoCMPPDrugAuthDetailsLookupView?action=token&apiName=' + CMPP_DRUG_SEARCH_END_POINT).done(function (data) {
					$('#cmppDrugNameTextID').val("");
					var object = JSON.parse(data);
					apiURL = object.apiURL;
					token = object.token;
					responseTimeout = object.responseTimeout;
					PharmacySearchWidget.petFormularyId = object.petFormularyId;
					jQuery.ajax({
						url: apiURL + object.generalFormularyId + '/cmppformularyproduct/?',
						type: 'GET',
						timeout: responseTimeout,
						headers: {
							"Content-Type": "application/json",
							"Accept": "application/json",
							'api-version': object.apiVersionNumber
						},
						beforeSend: function beforeSend(xhr) {
							xhr.setRequestHeader('Authorization', 'Bearer ' + token);
						},
						success: function success(response) {
							$('#div_formulary_savings_products_error_display').hide();
							PharmacySearchWidget.getFormularySavingProductsById(response);
							PharmacySearchWidget.getFormularyNewProductsById(response);
						},
						error: function error(xhr, ajaxOptions, thrownError) {
							$('#div_formulary_savings_products_display').hide();
							$('#div_formulary_savings_products_error_display').show();
							$('#new-to-cmpp').hide();
						}
					});
				});
			},
	
			/**
	   * getFormularyPetSavingsDrugAuthDetails is a method is used for getting the API End-Point and Token Information from the back-end.
	   * This method hit an external API for getting the formulary drug list 
	   * This method invokes a method getFormularySavingProductsById to display the results
	   * @param : formularyId
	   */
			getFormularyPetSavingsDrugAuthDetails: function getFormularyPetSavingsDrugAuthDetails() {
				if (PharmacySearchWidget.petFormularyId != '') {
					var CMPP_DRUG_SEARCH_END_POINT = 'CMPP_FORMULARY_PRODUCTS_BY_ID_END_POINT';
					var apiURL = '';
					var token = '';
					var responseTimeout = 0;
					$.get('/AjaxCostcoCMPPDrugAuthDetailsLookupView?action=token&apiName=' + CMPP_DRUG_SEARCH_END_POINT).done(function (data) {
						var object = JSON.parse(data);
						apiURL = object.apiURL;
						token = object.token;
						responseTimeout = object.responseTimeout;
						jQuery.ajax({
							url: apiURL + PharmacySearchWidget.petFormularyId + '/cmppformularyproduct/?',
							type: 'GET',
							timeout: responseTimeout,
							headers: {
								"Content-Type": "application/json",
								"Accept": "application/json",
								'api-version': object.apiVersionNumber
							},
							beforeSend: function beforeSend(xhr) {
								xhr.setRequestHeader('Authorization', 'Bearer ' + token);
							},
							success: function success(response) {
								$('#div_formulary_pet_savings_products_error_display').hide();
								PharmacySearchWidget.getFormularyPetMedicationsProductsById(response);
							},
							error: function error(xhr, ajaxOptions, thrownError) {
								$('#div_formulary_pet_savings_products_error_display').hide();
							}
						});
					});
				}
			},
	
			/**
	   * validateDrugForm is a method is used for validating the form search button after clicking.
	   */
			validateDrugForm: function validateDrugForm() {
				var isValid = true;
				var drugIdentifierVal = $('#drugIdentifierParam').val();
				if ($('#cmppDrugNameTextID').val() == "" || drugIdentifierVal == "" || typeof $('#' + drugIdentifierVal + '')[0] !== 'undefined' && $('#' + drugIdentifierVal + '').attr('aria-label').toLowerCase() !== $('#cmppDrugNameTextID').val().toLowerCase()) {
	
					return false;
				}
				return isValid;
			},
	
			/**
	   * Function used to identify the CMPP feature is Dormant or not
	   */
			isCMPPDormant: function isCMPPDormant() {
				$.get('/AjaxCostcoCMPPDormantCheckLookupView').done(function (data) {
					try {
						var isCMPPDormantFlag = $.trim(data.isCMPPDormantParam);
						return isCMPPDormantFlag;
					} catch (e) {
						return false;
					}
				});
			},
	
			/**
	   * Function used to display the error text in the widget
	   */
			displayErrorMessage: function displayErrorMessage(divId, errorTextParam) {
				var remark_html = '';
				remark_html += COSTCO.util.tmpl('tmpl_drug_error_display', {
					errorText: errorTextParam
				});
				$('#' + divId).append(remark_html);
			},
	
			/**
	   * getFormularySavingProductsById is a method is used for displaying formulary products for the Example of Savings.
	   * This method is invoke by the primary method getFormularySavingsDrugAuthDetails
	   * @param : data
	   */
			getFormularySavingProductsById: function getFormularySavingProductsById(data) {
				var remark_html = "";
				var object = data;
				var tableEntryLimit = 10;
				var tableEntriesAccepted = 0;
				remark_html += COSTCO.util.tmpl('tmpl_drug_genelral_formulary_details_heading', {});
				for (var i in object.items) {
					if (tableEntriesAccepted >= tableEntryLimit) {
						break;
					}
					//Logic to display the Drugs with 'IsTable' property in Savings table.
					if (object.items[i].hasOwnProperty('tags')) {
						var objTags = object.items[i].tags;
						if (objTags !== null && objTags !== undefined && Object.values(objTags).indexOf('IsTable') > -1) {
							var drugStrengthStr = !/^ *$/.test(object.items[i].strength) ? " - " + object.items[i].strength : "";
							remark_html += COSTCO.util.tmpl('templ_formulary_savings_products_display', {
								drugName: object.items[i].drugName,
								dosageForm: object.items[i].dosageForm,
								quantity: object.items[i].quantity,
								drugAndStrength: drugStrengthStr,
								drugPrice: COSTCO.PharmacySelfService.populateMinumumPrice(object.items[i])
							});
							tableEntriesAccepted++;
						}
					}
				}
				remark_html = remark_html + '</table>';
				$('#div_formulary_savings_products_display').html(remark_html);
				PharmacySearchWidget.getFormularyPetSavingsDrugAuthDetails();
			},
	
			/** getFormularyNewProductsById populates the desktop and mobile carousels with the products identified from API call
	   * as new to CMPP
	  */
			getFormularyNewProductsById: function getFormularyNewProductsById(data) {
				// remark_html used for building html to be used inside the cmpp carousel tile template
				var remark_html = '';
				// 'carouselTileLimit'used as a hard limiter to how many items are allowed to appear on the carousel. As of 11/22/21, no more than 12 tiles were to exist on the carousel
				var carouselTileLimit = 12;
				// 'carouselTilesAdded' used to compare agains limit and check if there are any items have been
				// added to the carousel
				var carouselTilesAdded = 0;
				var object = data;
				// iterate through items parsed from parsed JSON object 'data
				for (var i in object.items) {
					if (object.items[i].hasOwnProperty('tags')) {
						// initial check to see current iteration is not greater than the limit on the carousel
						if (carouselTilesAdded >= carouselTileLimit) {
							break;
						}
						// break object.items into an object that I can use to make sure this does become greater
						var objTags = object.items[i].tags;
						// once determined that object hold the 'isNew' tag, function begin to build the html using the template
						// created for the product tile used inside the CMPP carousel
						if (objTags !== null && objTags !== undefined && Object.values(objTags).indexOf('IsNew') > -1) {
							var price = COSTCO.util.localeSpecificCurrency(COSTCO.PharmacySelfService.populateMinumumPrice(object.items[i]), COSTCO.util.getLocale().substr(0, 2));
							var drugNameStr = object.items[i].isBrand == false ? object.items[i].drugName + " (Generic)" : object.items[i].drugName;
							var drugNameReqParam = object.items[i].drugName.replaceAll(/ /g, "+");
							var drugPackageOrFormParam = COSTCO.PharmacySelfService.getDrugPackageFormDescription(object.items[i].showPackageIndicator, object.items[i].packageDescription, object.items[i].dosageForm, object.items[i].strength, object.items[i].quantity, object.items[i].substitutionBrandDrugs);
							remark_html += COSTCO.util.tmpl('tmpl_new_to_cmpp_carousel_product_display', {
								drugIdentifierParam: object.items[i].drugIdentifier,
								drugNameParam: drugNameReqParam,
								drugName: drugNameStr,
								strengthDescription: drugPackageOrFormParam,
								drugPrice: price
							});
							carouselTilesAdded++;
						}
					}
				}
				// populate the CMPP carousels used for both the desktop and mobile view for CMPP after iterating through the parsed JSON object
				$('#new-to-cmpp-products-carousel-desktop').html(remark_html);
				$('#new-to-cmpp-products-carousel-mobile').html(remark_html);
				/**
	    * if 'carouselTilesAdded' is greater than 0, proceed with creating the carousel slick.js initialization, otherwise the section of the carousel will be hidden
	    */
				carouselTilesAdded > 0 ? COSTCO.PharmacySelfService.createCMPPCarousels() : $('#new-to-cmpp').hide();
			}
	
		};
	
		window.COSTCO.PharmacySearchWidget = PharmacySearchWidget;
		$(document).ready(function () {
			/**
	   * The customer will be redirected to the static content page, if the CMPP is dormant in XAPPLICATION config
	   */
			if (PharmacySearchWidget.isCMPPDormant()) {
				window.location.href = "Pharmacy/member-prescription-program.html";
			} else {
				/**
	    * Invoke getFormularySavingProductsById method for displaying Example of Savings drug list and new drugs to CMPP
	    */
				PharmacySearchWidget.getFormularySavingsDrugAuthDetails();
				/**
	    * Invoke getAutoSuggestedDrugNamesByKeyword method if the length of the keyword in the text field is more than 2.
	    */
				$("#cmppDrugNameTextID, #cmppAutoSuggest").keyup(function (e) {
					var li = $('ul#autoSuggestionsId li');
					var liSelected = $('ul#autoSuggestionsId li.selected');
					if (e.which === 40 || e.which === 38) {
						if (e.which === 40) {
							if (liSelected) {
								liSelected.removeClass('selected');
								next = liSelected.next();
								if (next.length > 0) {
									liSelected = next.addClass('selected').focus();
								} else {
									liSelected = li.eq(0).addClass('selected').focus();
								}
							} else {
								liSelected = li.eq(0).addClass('selected').focus();
							}
						} else if (e.which === 38) {
							if (liSelected) {
								liSelected.removeClass('selected');
								next = liSelected.prev();
								if (next.length > 0) {
									liSelected = next.addClass('selected').focus();
								} else {
									liSelected = li.last().addClass('selected').focus();
								}
							} else {
								liSelected = li.last().addClass('selected').focus();
							}
						}
						e.preventDefault();
						$("#cmppDrugNameTextID").val(liSelected.attr('aria-label'));
						$('label[for="cmppDrugNameTextID"]').addClass('active');
					}
	
					$('#cmppDrugNameTextID').removeClass('error');
					var drugSearchKeyword = $.trim($(this).val());
					if (drugSearchKeyword.length >= PharmacySearchWidget.drugSearchMaxLength && e.which != 40 && e.which != 38) {
						PharmacySearchWidget.getAutoSuggestedDrugAuthDetails(drugSearchKeyword);
					}
				});
				$("#cmppDrugNameTextID, #cmppAutoSuggest").keydown(function (e) {
					if (e.which === 40 || e.which === 38) {
						e.preventDefault();
					}
				});
	
				/**
	    * Form will be submitted once the user the click on the submit button
	    */
				$('#cmppSubmitId').on('click', function () {
					var validationSuccess = PharmacySearchWidget.validateDrugForm();
					if (validationSuccess) {
						$("#cmppSubmitFormId").submit();
					} else {
						$('#div_drugNameAutoSuggestionsError').show();
						$('#cmppDrugNameTextID').addClass('error');
						$('#div_drugNameAutoSuggestionsError').addClass('error');
						var displayError = '';
						displayError += COSTCO.util.tmpl('templ_drug_names_suggestions_error_display', {});
						$('#div_drugNameAutoSuggestionsError').html(displayError);
						$('.cmppAutoSuggest').hide();
					}
				});
				/**
	    * Form will be submitted once the user press the Enter button in the text field blur
	    */
				$('#cmppDrugNameTextID').keypress(function (event) {
					if (event.which == PharmacySearchWidget.EnterKeywordCode) {
						var validationSuccess = PharmacySearchWidget.validateDrugForm();
						if (validationSuccess) {
							$("#cmppSubmitFormId").submit();
						} else {
							$('#div_drugNameAutoSuggestionsError').show();
							$('#cmppDrugNameTextID').addClass('error');
							$('#div_drugNameAutoSuggestionsError').addClass('error');
							var displayError = '';
							displayError += COSTCO.util.tmpl('templ_drug_names_suggestions_error_display', {});
							$('#div_drugNameAutoSuggestionsError').html(displayError);
							$('.cmppAutoSuggest').hide();
							event.preventDefault();
							return false;
						}
					}
				});
	
				$('#cmppDrugNameTextID').focusin(function () {
					var drugSearchKeyword = $.trim($(this).val());
					if (drugSearchKeyword.length >= PharmacySearchWidget.drugSearchMaxLength) {
						PharmacySearchWidget.getAutoSuggestedDrugAuthDetails(drugSearchKeyword);
					}
				});
				$(document).mouseup(function (e) {
					var container = $("#search-price-container");
					if (!container.is(e.target) && container.has(e.target).length === 0) {
						window.setTimeout(function () {
							$('.cmppAutoSuggest').hide();
							$('#cmppDrugNameTextID').removeClass('error');
							$('#div_drugNameAutoSuggestionsError').removeClass('error');
							$('#div_drugNameAutoSuggestionsError').hide();
						}, 300);
					}
				});
				$('#cmppDrugNameTextID').on('input', function () {
					var drugSearchKeyword = $.trim($(this).val());
					if (drugSearchKeyword.length < PharmacySearchWidget.drugSearchMaxLength) {
						$('#cmppAutoSuggest').hide();
						var displayError = '';
						$('#cmppDrugNameTextID').removeClass('error');
						$('#div_drugNameAutoSuggestionsError').html(displayError);
					}
				});
			}
		});
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// pharmacysearchwidget.module.min.js